import { FontWeight } from 'commons/typography';

export const spacing = {
  input: {
    borderRadius: '8px',
    height: '40px',
  },
  reportSidePadding: '40px',
  scrollbarSize: '8px',
  detailsSidePadding: '70px',
  menuWidth: '72px',
};

export const inputStyle = {
  fontWeight: FontWeight.regular,
  placeholderOpacity: '0.7',
};

export const device = {
  mobile: 432,
  tablet: 768,
  desktopSmall: 1024,
  desktop: 1366,
};
